import classNames from 'classnames';
import React, { MouseEventHandler } from 'react';
import ArrowLeft from './arrow-left.svg';
import ArrowRight from './arrow-right.svg';
import styles from './styles.scss';

const ArrowButton = ({
  isRight,
  onClick,
  hoverClass,
  className,
}: {
  isRight?: boolean;
  onClick?: MouseEventHandler;
  hoverClass?: string;
  className?: string;
}): JSX.Element => {
  return (
    <button
      className={classNames(styles.arrowButton, hoverClass && hoverClass, className && className)}
      onClick={onClick}
    >
      {isRight ? <ArrowRight /> : <ArrowLeft />}
    </button>
  );
};

export default ArrowButton;
